export enum CountrySource {
  Delegation = 1,
  Card = 2,
  Mix = 3,
  DestinationCountry = 4,
}
